import { Text } from '@chakra-ui/react'
import { DateTime } from 'luxon'
import { ItListStatus } from 'types/graphql'

import { toAgoString } from 'src/lib/utils'

const StatusAsOwner = ({
  status,
  updatedAt,
}: {
  status: ItListStatus
  updatedAt: string
}) => (
  <>
    <Text
      as="span"
      color={status === 'published' ? 'successful' : ''}
      className="body-extra-small-emphasis"
    >
      {status === 'published' ? 'Live' : 'Draft'}
    </Text>
    &nbsp;•&nbsp;Edited {toAgoString(DateTime.fromISO(updatedAt))}
  </>
)

export default StatusAsOwner
